import { render, staticRenderFns } from "./VsmStatusHistoryList.vue?vue&type=template&id=751d7f70&"
import script from "./VsmStatusHistoryList.vue?vue&type=script&lang=js&"
export * from "./VsmStatusHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports